// ─────────────────────────────────────────────────────────
// ZIKO Analytics — GA4 ecommerce event tracking utility
// ─────────────────────────────────────────────────────────

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GA_ID = 'G-M99ENQ6RFG';

const gtag = (...args: any[]) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

// ── Page view (fires automatically on route change via App.tsx) ──────
export const trackPageView = (path: string, title?: string) => {
  gtag('config', GA_ID, {
    page_path: path,
    page_title: title || document.title,
  });
};

// ── Product viewed ───────────────────────────────────────
export const trackViewItem = (product: {
  id: string; title: string; price: number; category: string;
}) => {
  gtag('event', 'view_item', {
    currency: 'EGP',
    value: product.price,
    items: [{
      item_id: product.id,
      item_name: product.title,
      item_category: product.category,
      price: product.price,
      quantity: 1,
    }],
  });
};

// ── Add to cart ──────────────────────────────────────────
export const trackAddToCart = (product: {
  id: string; title: string; price: number; category: string; quantity?: number;
}) => {
  gtag('event', 'add_to_cart', {
    currency: 'EGP',
    value: product.price * (product.quantity || 1),
    items: [{
      item_id: product.id,
      item_name: product.title,
      item_category: product.category,
      price: product.price,
      quantity: product.quantity || 1,
    }],
  });
};

// ── Begin checkout ───────────────────────────────────────
export const trackBeginCheckout = (items: any[], total: number) => {
  gtag('event', 'begin_checkout', {
    currency: 'EGP',
    value: total,
    items: items.map(i => ({
      item_id: i.id,
      item_name: i.title,
      item_category: i.category,
      price: i.price,
      quantity: i.quantity,
    })),
  });
};

// ── Purchase complete ────────────────────────────────────
export const trackPurchase = (order: {
  orderRef: string;
  total: number;
  subtotal: number;
  discount: number;
  paymentMethod: string;
  items: any[];
}) => {
  gtag('event', 'purchase', {
    transaction_id: order.orderRef,
    currency: 'EGP',
    value: order.total,
    coupon: '',
    shipping: 0,
    tax: 0,
    items: order.items.map(i => ({
      item_id: i.id,
      item_name: i.title,
      item_category: i.category,
      price: i.price,
      quantity: i.quantity,
    })),
  });
};

// ── Search ───────────────────────────────────────────────
export const trackSearch = (term: string) => {
  gtag('event', 'search', { search_term: term });
};

// ── Newsletter signup ────────────────────────────────────
export const trackNewsletterSignup = () => {
  gtag('event', 'generate_lead', { currency: 'EGP', value: 0 });
};

// ── Share / social ───────────────────────────────────────
export const trackShare = (method: string, itemId: string) => {
  gtag('event', 'share', { method, item_id: itemId });
};

